import { useSortable } from '@dnd-kit/sortable'
import clsx from 'clsx'
import { AppButton } from 'shared/components/MainLayout/components/AppButton'
import { transformAppConfigToAppData } from 'shared/components/MainLayout/components/AppButton/utils/appDataTransform'
import { HotkeyTooltip } from 'src/shared/components/HotkeyTooltip/HotkeyTooltip'

import styles from '../../TopDock.module.scss'
import { SortableAppButtonProps } from './SortableAppButton.types'

export const SortableAppButton = ({
  app,
  index,
  handleAppClick,
  iconRefs,
  scrollButtonIntoView,
  isLoading
}: SortableAppButtonProps) => {
  const appData = transformAppConfigToAppData(app)

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: appData.id })

  const style = {
    transform: transform
      ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
      : undefined,
    transition,
    opacity: isDragging ? 0.5 : 1
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={clsx(styles.sortableItem, isDragging && styles.isDragging)}
    >
      <HotkeyTooltip
        keys={['meta', index > 9 ? 'alt' : '', String((index + 1) % 10)]}
        onPress={() => handleAppClick?.(appData, 'topDock')}
        label={appData.label}
        previewHotkeysOnPress={false}
      >
        <AppButton
          buttonType='topDock'
          tourId={`top-dock-${appData.name!}`}
          iconRefs={iconRefs}
          index={index}
          app={appData}
          onClick={() => {
            handleAppClick?.(appData, 'topDock')
          }}
          onLabelAnimationComplete={() => {
            const iconElement = iconRefs?.current?.[appData.id]
            if (iconElement) {
              const buttonWrapper = iconElement.closest(
                '[data-app-button-wrapper]'
              ) as HTMLElement | null
              scrollButtonIntoView(buttonWrapper)
            }
          }}
          isLoading={isLoading}
          isLocked={app.isDisabled}
        />
      </HotkeyTooltip>
    </div>
  )
}
